import React, { useMemo } from "react";
import {
  PopoverContentContainer,
  PopoverContentItem,
} from "../../../../components/Events/ChooseSeasonSelector/ChooseSeasonSelector";
import {
  buildParameterColorMap,
  FALLBACK_EVENT_COLOR,
} from "../../../../helpers/eventMarkerColors";

const toKey = (value) => {
  if (value === null || value === undefined) {
    return "";
  }

  return String(value);
};

const resolveActionLabel = (action, l) => {
  const lexicId = action?.lexic_id ?? action?.lexic ?? action?.lexc;
  return l?.(lexicId) || action?.title || action?.name || "";
};

const resolveParameterId = (action) => {
  return toKey(
    action?.team_parameter_id ??
      action?.teamParameterId ??
      action?.parameter_id ??
      action?.parameterId ??
      action?.id
  );
};

const resolveGroupTitle = (groupKey, l) => {
  const parsedKey = Number(groupKey);

  if (Number.isNaN(parsedKey)) {
    return l?.(groupKey) || groupKey;
  }

  return l?.(parsedKey) || groupKey;
};

const SelectedActionsPopoverContent = ({ groupedSelectedActions, l }) => {
  const selectedActions = useMemo(() => {
    return Object.values(groupedSelectedActions || {}).flat();
  }, [groupedSelectedActions]);

  const parameterColorMap = useMemo(() => {
    return buildParameterColorMap(selectedActions);
  }, [selectedActions]);

  if (!groupedSelectedActions) {
    return null;
  }

  return (
    <PopoverContentContainer>
      {Object.entries(groupedSelectedActions).map(([groupKey, actions]) => {
        return (
          <PopoverContentItem key={groupKey}>
            <b>{resolveGroupTitle(groupKey, l)}</b>
            <div className="matches-list">
              {(actions || []).map((action, index) => {
                const parameterId = resolveParameterId(action);
                const color = parameterColorMap[parameterId] || FALLBACK_EVENT_COLOR;
                const label = resolveActionLabel(action, l);
                const actionKey =
                  parameterId ||
                  `${groupKey}-${action?.name || action?.title || action?.lexic_id || action?.lexic || action?.lexc || index}`;

                return (
                  <div
                    key={actionKey}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      marginBottom: 6,
                      whiteSpace: "normal",
                    }}
                  >
                    <span
                      style={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        backgroundColor: color,
                        border: "1px solid rgba(8, 10, 14, 0.9)",
                        flexShrink: 0,
                      }}
                    />
                    <span>{label}</span>
                  </div>
                );
              })}
            </div>
          </PopoverContentItem>
        );
      })}
    </PopoverContentContainer>
  );
};

export default SelectedActionsPopoverContent;
